function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1928(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26.06,
    height: 10.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.255
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.03,
    y: 5.02
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10.04,
    width: 26.06,
    height: 28.12,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.03,
    y: 24.1
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 38.15,
    width: 26.06,
    height: 29.8,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.343333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.03,
    y: 53.05
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 67.95,
    width: 26.06,
    height: 40.1,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.212
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.03,
    y: 88
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 108.05,
    width: 26.06,
    height: 43.58,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.895555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.03,
    y: 129.84
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 151.63,
    width: 26.06,
    height: 48.42,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.212
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.03,
    y: 175.84
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 200.05,
    width: 26.06,
    height: 50.96,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.343333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.03,
    y: 225.53
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 251.01,
    width: 26.06,
    height: 55.31,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.212
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.03,
    y: 278.66499999999996
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 306.32,
    width: 26.06,
    height: 60.98,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.343333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.03,
    y: 336.81
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 367.3,
    width: 26.06,
    height: 61.01,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.722857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.03,
    y: 397.805
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 428.3,
    width: 26.06,
    height: 64.68,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.722857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.03,
    y: 460.64
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 492.98,
    width: 26.06,
    height: 67.31,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.212
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.03,
    y: 526.635
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 560.29,
    width: 26.06,
    height: 67.74,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.03,
    y: 594.16
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 628.03,
    width: 26.06,
    height: 71.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.03,
    y: 664.015
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.06,
    y: 0,
    width: 43.41,
    height: 46.31,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.42625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.765,
    y: 23.155
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.47,
    y: 0,
    width: 43.62,
    height: 46.31,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.362
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 91.28,
    y: 23.155
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 113.08,
    y: 0,
    width: 44.48,
    height: 46.31,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.413333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.32,
    y: 23.155
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.56,
    y: 0,
    width: 45.09,
    height: 46.31,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.441428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 180.10500000000002,
    y: 23.155
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202.65,
    y: 0,
    width: 45.74,
    height: 46.31,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.7175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.52,
    y: 23.155
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.39,
    y: 0,
    width: 46.1,
    height: 46.31,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.585714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 271.44,
    y: 23.155
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.49,
    y: 0,
    width: 46.59,
    height: 46.31,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.78875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 317.785,
    y: 23.155
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.09,
    y: 0,
    width: 47.68,
    height: 46.31,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.615714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 364.92999999999995,
    y: 23.155
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 388.77,
    y: 0,
    width: 47.72,
    height: 46.31,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.78875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 412.63,
    y: 23.155
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436.48,
    y: 0,
    width: 49.51,
    height: 46.31,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.78875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461.235,
    y: 23.155
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.99,
    y: 0,
    width: 49.59,
    height: 46.31,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.78875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 510.785,
    y: 23.155
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 535.58,
    y: 0,
    width: 50.77,
    height: 46.31,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.718333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.965,
    y: 23.155
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 586.35,
    y: 0,
    width: 55.63,
    height: 46.31,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.631
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 614.1650000000001,
    y: 23.155
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 641.98,
    y: 0,
    width: 58.02,
    height: 46.31,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.262
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.99,
    y: 23.155
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.06,
    y: 46.31,
    width: 58,
    height: 47.19,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.864999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.06,
    y: 69.905
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.06,
    y: 93.49,
    width: 58,
    height: 48.53,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.853
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.06,
    y: 117.755
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.06,
    y: 142.03,
    width: 58,
    height: 50,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.06,
    y: 167.03
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.06,
    y: 192.02,
    width: 58,
    height: 52.21,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.458571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.06,
    y: 218.125
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.06,
    y: 244.23,
    width: 58,
    height: 56.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.12125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.06,
    y: 272.715
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.06,
    y: 301.21,
    width: 58,
    height: 61.72,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.06,
    y: 332.07
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.06,
    y: 362.93,
    width: 58,
    height: 62.37,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.666666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.06,
    y: 394.115
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.06,
    y: 425.3,
    width: 58,
    height: 63.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.2727272727272725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.06,
    y: 456.945
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.06,
    y: 488.59,
    width: 58,
    height: 65.07,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.666666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.06,
    y: 521.125
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.06,
    y: 553.65,
    width: 58,
    height: 71.63,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.285714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.06,
    y: 589.4649999999999
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.06,
    y: 625.29,
    width: 58,
    height: 74.71,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.833333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.06,
    y: 662.645
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.05,
    y: 46.31,
    width: 64.52,
    height: 68.42,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.168888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.31,
    y: 80.52000000000001
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.58,
    y: 46.31,
    width: 65.78,
    height: 68.42,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.397142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 181.47000000000003,
    y: 80.52000000000001
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.35,
    y: 46.31,
    width: 66.15,
    height: 68.42,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 247.425,
    y: 80.52000000000001
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.5,
    y: 46.31,
    width: 76.07,
    height: 68.42,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.5525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.53499999999997,
    y: 80.52000000000001
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 356.57,
    y: 46.31,
    width: 84.54,
    height: 68.42,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.22
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 398.84,
    y: 80.52000000000001
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 441.11,
    y: 46.31,
    width: 85.26,
    height: 68.42,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.774285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 483.74,
    y: 80.52000000000001
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 526.37,
    y: 46.31,
    width: 85.47,
    height: 68.42,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.8420000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 569.105,
    y: 80.52000000000001
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 611.84,
    y: 46.31,
    width: 88.16,
    height: 68.42,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.5525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 655.9200000000001,
    y: 80.52000000000001
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.05,
    y: 114.73,
    width: 84.9,
    height: 76.3,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.716666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.5,
    y: 152.88
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.05,
    y: 191.03,
    width: 84.9,
    height: 80.03,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.338333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.5,
    y: 231.04500000000002
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.05,
    y: 271.06,
    width: 84.9,
    height: 82.94,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.848571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.5,
    y: 312.53
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.05,
    y: 354,
    width: 84.9,
    height: 86.71,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.49
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.5,
    y: 397.355
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.05,
    y: 440.71,
    width: 84.9,
    height: 111.07,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.5,
    y: 496.245
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.05,
    y: 551.78,
    width: 84.9,
    height: 148.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.5,
    y: 625.89
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.96,
    y: 114.73,
    width: 96.88,
    height: 130.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.146666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 217.4,
    y: 179.84
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.84,
    y: 114.73,
    width: 114.2,
    height: 130.22,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 322.94,
    y: 179.84
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 380.04,
    y: 114.73,
    width: 152.95,
    height: 130.22,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.703333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 456.515,
    y: 179.84
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 532.99,
    y: 114.73,
    width: 167.01,
    height: 130.22,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.838181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 616.495,
    y: 179.84
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.96,
    y: 244.96,
    width: 152.94,
    height: 204.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 38.235
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 245.43,
    y: 347.42
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.96,
    y: 449.88,
    width: 152.94,
    height: 250.12,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 30.588
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 245.43,
    y: 574.94
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321.9,
    y: 244.96,
    width: 150.68,
    height: 255.07,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.113333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 397.24,
    y: 372.495
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 472.58,
    y: 244.96,
    width: 227.42,
    height: 255.07,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 28.4275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 586.29,
    y: 372.495
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321.9,
    y: 500.02,
    width: 378.1,
    height: 199.98,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 39.995999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 510.95,
    y: 600.01
  }, "\n        Kings\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1928);
export default __webpack_public_path__ + "static/media/1928.ff9aa068214c9088a4cca9816ef56170.svg";
export { ForwardRef as ReactComponent };